import InsufficientPermissionsPage from 'components/core/InsufficientPermissionsPage/InsufficientPermissionsPage';
import { isAdmin } from 'shared/domain/role/isAdmin';
import React from 'react';
import { useCurrentUserRole } from 'store/user';
import { ProjectSettingsView } from 'views/projects/settings';
import { MemoGenericRoleAuthorizer } from '../GenericRoleAuthorizer';
import { MemoEditProjectWizardContainer } from 'views/projects/wizard/edit/container';

export const AuthorizableProjectSettingsView = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();

    const isCurrentUserAdmin = isAdmin(role);

    return (
      <MemoGenericRoleAuthorizer
        authorized={isCurrentUserAdmin}
        unauthorized={!isCurrentUserAdmin}
        authorizedComponent={ProjectSettingsView}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);

export const AuthorizableEditProjectWizard = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();
    const isCurrentUserAdmin = isAdmin(role);
    return (
      <MemoGenericRoleAuthorizer
        authorized={isCurrentUserAdmin}
        unauthorized={!isCurrentUserAdmin}
        authorizedComponent={MemoEditProjectWizardContainer}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);
